module.exports = "images/doc-service-menu.583acdd7e7fe570068f6b180e6dce95c.png";